import moment from 'moment';
import { DATE_TIME_FORMAT, PRICE_MAKEUP } from '../constants/Define';
import { getMomentDate } from './../utils/commonUtils';

export default class Flight {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.transactionCode = data.transactionCode || undefined;
        this.departureCode = data.departureCode || undefined;
        this.departureLastTkDate = getDate(data.departureLastTkDate, undefined, false);
        this.departureMessage = data.departureMessage || undefined;
        this.departureStatus = data.departureStatus || undefined;
        this.returnCode = data.returnCode || undefined;
        this.returnLastTkDate = getDate(data.returnLastTkDate, undefined, false);
        this.returnMessage = data.returnMessage || undefined;
        this.returnStatus = data.returnStatus || undefined;
        this.totalPrice = data.totalPrice || 0;
        this.issueTicketStatus = data.issueTicketStatus || undefined;
        this.status = data.status || undefined;
        this.departureOrderStatus = data.departureOrderStatus || undefined;
        this.returnOrderStatus = data.returnOrderStatus || undefined;
        this.setPassengerInfo(data);
        this.setContactInfo(data);
        this.setFlightInfo(data);
        this.setBaggageInfo(data);
    }

    setPassengerInfo(data={}){
        this.passengerInfo = (data.passengerInfo || []).map(item => new PassengerInfo(item || {}))
    }

    setContactInfo(data={}){
        this.contactInfo = new ContactInfo(data.contactInfo || {})
    }

    setFlightInfo(data={}){
        this.flightInfo = new FlightInfo(data.flightInfo || {})
    }

    setBaggageInfo(data={}){
        this.baggageInfo = new BaggageInfo(data.baggageInfo || {})
    }

    export() {
        return {
            id: this.id,
            departureCode: this.departureCode,
            departureLastTkDate: this.departureLastTkDate && (this.departureLastTkDate).toISOString(),
            departureMessage: this.departureMessage,
            departureStatus: this.departureStatus,
            returnCode: this.returnCode,
            returnLastTkDate: this.returnLastTkDate && (this.returnLastTkDate).toISOString(),
            returnMessage: this.returnMessage,
            returnStatus: this.returnStatus
        }
    }
}

// FLIGHT INFOS

export class FlightInfo {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.departureFlights = new FlightDirectionInfo(data.departureFlights || {});
        this.returnFlights = new FlightDirectionInfo(data.returnFlights || {});
        this.flightGroups = data.flightGroups || undefined;
        this.itineraryType = data.itineraryType || undefined;
        this.departureDate = getDate(data.departureDate, DATE_TIME_FORMAT.SHORT_DATE);
        this.returnDate = getDate(data.returnDate, DATE_TIME_FORMAT.SHORT_DATE);
        this.startPoint = data.startPoint || undefined;
        this.endPoint = data.endPoint || undefined;
        this.adult = data.adult || 0;
        this.children = data.children || 0;
        this.infant = data.infant || 0;
        this.dataSession = data.dataSession || undefined;
        this.isDomestic = data.isDomestic !== undefined ? data.isDomestic : false;
        this.departAccountName = data.departAccountName !== undefined ? data.departAccountName: ''
        this.departSourceName = data.departSourceName !== undefined ? data.departSourceName: ''
        this.returnAccountName = data.returnAccountName !== undefined ? data.returnAccountName: ''
        this.returnSourceName = data.returnSourceName !== undefined ? data.returnSourceName: ''
    }
}

export class FlightDirectionInfo {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.setFareOptions(data);
        this.startPoint = data.startPoint || undefined;
        this.endPoint = data.endPoint || undefined;
        this.flightSession = data.flightSession || undefined;
        this.flightNumber = data.flightNumber || undefined;
        this.airlineCode = data.airlineCode || undefined;
        this.airlineName = data.airlineName || undefined;
        this.airlineImage = data.airlineImage || undefined;
        this.startDate = getDate(data.startDate, undefined, false);
        this.endDate = getDate(data.endDate, undefined, false);
        this.stops = data.stops || 0;
        this.duration = data.duration || 0;
        this.setListSegment(data);
    }

    setFareOptions(data={}){
        this.fareOptions = (data.fareOptions || []).map(item => new FlightFare(item))
    }

    setListSegment(data={}){
        this.listSegment = (data.listSegment || []).map(item => new FlightSegment(item))
    }
}

export class FlightFare {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.priceAdult = data.priceAdult || undefined;
        this.priceChild = data.priceChild || 0;
        this.priceInfant = data.priceInfant || 0;
        this.feeAdult = data.feeAdult || 0;
        this.feeChild = data.feeChild || 0;
        this.feeInfant = data.feeInfant || 0;
        this.taxAdult = data.taxAdult || 0;
        this.taxChild = data.taxChild || 0;
        this.taxInfant = data.taxInfant || 0;
        this.totalPrice = data.totalPrice || 0;
        this.serviceFee = data.serviceFee || 0;
        this.vptServiceFee = data.vptServiceFee || 0;
        this.issueFee = data.issueFee || 0;
        this.seatRemaining = data.seatRemaining || 0;
        this.lastTkDate = getDate(data.lastTkDate);
        this.class = data.class || undefined;
        this.fareOptionSession = data.fareOptionSession || undefined;
        this.markupPrice = data.markupPrice || 0;
    }
}

export class FlightSegment {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.airlineCode = data.airlineCode || undefined;
        this.airlineName = data.airlineName || undefined;
        this.airlineImage = data.airlineImage || undefined;
        this.startDate = getDate(data.startDate, undefined, false);
        this.endDate = getDate(data.endDate, undefined, false);
        this.startPoint = data.startPoint || undefined;
        this.startPointName = data.startPointName || undefined;
        this.startPointCityName = data.startPointCityName || undefined;
        this.endPoint = data.endPoint || undefined;
        this.endPointName = data.endPointName || undefined;
        this.endPointCityName = data.endPointCityName || undefined;
        this.flightNumber = data.flightNumber || undefined;
        this.plane = data.plane || undefined;
        this.flightTime = data.flightTime || undefined;
        this.class = data.class || undefined;
    }
}

// PassengerInfo

export class PassengerInfo {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.firstName = data.firstName || undefined;
        this.lastName = data.lastName || undefined;
        this.type = data.type || undefined;
        this.gender = data.gender || 0;
        this.email = data.email || undefined;
        this.phone = data.phone || undefined;
        this.birthday = data.birthday && getDate(data.birthday, DATE_TIME_FORMAT.SHORT_DATE, false);
        this.passportExpiryDate = data.passportExpiryDate || undefined;
        this.passportIssueCountry = data.passportIssueCountry || undefined;
        this.passportNumber = data.passportNumber || undefined;
        this.baggageDeparture = data.baggageDeparture || undefined;
        this.baggageDeparturePrice = data.baggageDeparturePrice || undefined;
        this.baggageReturn = data.baggageReturn || undefined;
        this.baggageReturnPrice = data.baggageReturnPrice || undefined;
        this.departureTicketNumber = data.departureTicketNumber || undefined;
        this.returnTicketNumber = data.returnTicketNumber || undefined;
    }
}

// ContactInfo

export class ContactInfo {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.firstName = data.firstName || undefined;
        this.lastName = data.lastName || undefined;
        this.gender = data.gender || undefined;
        this.email = data.email || undefined;
        this.phone = data.phone || undefined;
        this.address = data.address || undefined;
        this.company = data.company || undefined;
        this.note = data.note || undefined;
    }
}

export class BaggageInfo {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.departure = data.baggageDeparture || 0;
        this.return = data.baggageReturn || 0;
    }
}

export class FlightConfig {
    constructor(data={}){
        this.setData(data);
    }

    setData(data={}){
        this.id = data.id || undefined;
        this.feePerTicker = data.feePerTicker || 0;
        this.percentPerTicker = data.percentPerTicker || 0;
        this.startDate = getDate(data.startDate);
        this.endDate = getDate(data.endDate);
        this.type = data.type || PRICE_MAKEUP.TYPE.AMOUNT;
    }

    export(){
        return {
            id: this.id,
            feePerTicker: this.feePerTicker,
            percentPerTicker: this.percentPerTicker,
            startDate: this.startDate && this.startDate.toISOString(),
            endDate: this.endDate && this.endDate.toISOString(),
            type: this.type,
        }
    }
}

function getDate(dateString, format=undefined, convertUTC=true) {
    return getMomentDate(dateString, format, convertUTC)
}